import { Switch } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function SwitchButton() {
  const [showSwitch, setShowSwitch] = useState(false);
  const navigate = useNavigate();
    const [showSwitchc, setShowSwitchc] = useState(false);

 
  // Component mount hote hi localStorage check karo
  useEffect(() => {
    const currentSwitch = localStorage.getItem("current_switch");

    if (currentSwitch) {
      setShowSwitchc(true) // Agar entry hai to switch mat dikhao
      
    }
  }, []);

  const handlePortalChange = (checked) => {
    const newRole = checked ? "admin" : "learner";

    // localStorage update karo
    localStorage.setItem("current_switch", newRole);

    // state update karo
   

    // root url pe redirect + refresh
    navigate("/");
    window.location.reload();
  };

  // Agar localStorage me entry nahi hai to switch mat dikhao
  if (!showSwitchc) return null;

  return (
    <Switch
      checked={showSwitch}
      onChange={handlePortalChange}
      checkedChildren={<UserOutlined />}
      unCheckedChildren={<UserOutlined />}
      style={{
        transform: "scale(1.3)",
        marginLeft: "15px",
      }}
    />
  );
}

export default SwitchButton;